import { render, staticRenderFns } from "./EditReceiversPage.vue?vue&type=template&id=b9de15f2&"
import script from "./EditReceiversPage.vue?vue&type=script&lang=ts&"
export * from "./EditReceiversPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports